/**
 * Product page: share button on the photo, and the floating Add to bag /
 * Buy now bar. The bar drives the real product form so variant, quantity and
 * the custom wishing message all carry over.
 */
(function () {
  function toast(root) {
    var el = root.querySelector('.kamal-pactions__toast');
    if (!el) return;
    el.hidden = false;
    setTimeout(function () {
      el.hidden = true;
    }, 1800);
  }

  document.addEventListener('click', function (event) {
    var share = event.target.closest('[data-kamal-share]');
    if (share) {
      var data = { title: share.dataset.shareTitle, url: share.dataset.shareUrl };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () {
          toast(share.closest('.kamal-pactions'));
        });
      }
      return;
    }

    var bar = event.target.closest('[data-kamal-sticky-buy]');
    if (!bar) return;
    var form = document.getElementById(bar.dataset.formId);
    if (!form) return;

    if (event.target.closest('[data-kamal-add]')) {
      var submit = form.querySelector('[type="submit"][name="add"]');
      if (submit) submit.click();
      return;
    }

    var buy = event.target.closest('[data-kamal-buy]');
    if (buy) {
      buy.classList.add('is-loading');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = window.Shopify.routes.root + 'checkout';
        })
        .catch(function () {
          buy.classList.remove('is-loading');
          var submitBtn = form.querySelector('[type="submit"][name="add"]');
          if (submitBtn) submitBtn.click();
        });
    }
  });

  // Mirror the real button's disabled / sold-out state when a variant changes.
  function syncState() {
    var bar = document.querySelector('[data-kamal-sticky-buy]');
    if (!bar) return;
    var form = document.getElementById(bar.dataset.formId);
    var submit = form && form.querySelector('[type="submit"][name="add"]');
    if (!submit) return;
    var soldOut = submit.disabled;
    var add = bar.querySelector('[data-kamal-add]');
    var buy = bar.querySelector('[data-kamal-buy]');
    // Only write when the value changes, otherwise the MutationObserver
    // re-triggers itself forever and freezes the page.
    if (add.disabled !== soldOut) add.disabled = soldOut;
    if (buy.disabled !== soldOut) buy.disabled = soldOut;
    var label = add.querySelector('span');
    var text = soldOut ? 'Sold out' : 'Add to bag';
    if (label.textContent !== text) label.textContent = text;
  }

  new MutationObserver(syncState).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });
  document.addEventListener('DOMContentLoaded', syncState);
})();
